import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../../modules/infra/i18n';
import DownloadReportModal from '../DownloadReportModal';

const DownloadAdpReportButton = ({
  modalOn,
  modalOff,
  modalIsOn,
  shopAction,
  brandAction,
}) => (
  <div className="u-inline-block">
    <button className="c-btn c-btn--primary" onClick={modalOn}>
      {t('reports:payouts.adp_button')}
    </button>
    <DownloadReportModal
      close={modalOff}
      display-if={modalIsOn}
      title={t('reports:payouts.adp_modal_title')}
      shopAction={shopAction}
      brandAction={brandAction}
    />
  </div>
);

DownloadAdpReportButton.propTypes = {
  modalOn: PropTypes.func.isRequired,
  modalOff: PropTypes.func.isRequired,
  modalIsOn: PropTypes.bool.isRequired,
  shopAction: PropTypes.func.isRequired,
  brandAction: PropTypes.func.isRequired,
};

export default DownloadAdpReportButton;
